import React, { useRef, useState } from "react";
import "./PageConfig.scss";
import {
  Collapse,
  Form,
  Row,
  Col,
  Input,
  Upload,
  Button, Switch,
  Spin
} from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { Editor } from "@tinymce/tinymce-react";
import { LandingPageService } from "../../../../src/core/services/landing_page_service";
import { openNotificationWithIcon } from "../../../../src/utilities/notificationWithIcon";
import { Title } from "@frontend/components/atoms/Title";
import { getFileNameFromUrl } from "@frontend/src/utilities/urlHelpers";
import { createPlaywrightForm } from "../../../selection_processes/createPlaywrightForm";
const { Panel } = Collapse;
const { Dragger } = Upload;


// Refactor de portales: Eliminar este archivo  
const PageConfigForm = ({ landingPage, form }) => {
  const { id, link, title, description, image_or_video, banner } = landingPage;
  const [linkValue, setLinkValue] = useState(link);
  const [descriptionValue, setDescriptionValue] = useState(description)
  const [showAreaFilter, setShowAreaFilter] = useState(landingPage.show_area_filter)
  const [uploaderState, setUploaderState] = useState({loading: false, url: image_or_video?.url})
  const [bannerUploaderState, setBannerUploaderState] = useState({loading: false, url: banner?.url})
  const { getFieldDecorator} = form

  const landingPageService = new LandingPageService();

  const editorRef = useRef(null);
  const log = () => {
    if (editorRef.current) {
      console.log(editorRef.current.getContent());
    }
  };

  const copy = async () => {
    await navigator.clipboard.writeText(linkValue);
    openNotificationWithIcon("success", "Texto copiado", "");
  };

  const handleUpdatePage = (e) => {
    e.preventDefault()
    form.validateFields((err, values) => {
      landingPageService.updateRecord(
        id,
        {...values, description: descriptionValue, show_area_filter: showAreaFilter},
        (data) => {
          openNotificationWithIcon("success", "Actualización correcta", "");
          setUploaderState({loading: false, url: data.data.image_or_video?.url })
          setBannerUploaderState({loading: false, url: data.data.banner?.url })
        },
        () => {
          openNotificationWithIcon(
            "error",
            "Lo sentimos!",
            "Ocurrió un error al actualizar los datos."
          );
        }
      );
    })
  };

  const uploaderProps = {
    name: "image_or_video",
    action: `/api/v1/landing_pages/${id}`,
    method: "put",
    maxCount: 1,
    fileList: uploaderState.url ? [{
        uid: '-1',
        name: getFileNameFromUrl(uploaderState.url || null),
        status: 'done',
        url: image_or_video.url,
      }] : [],
    onRemove: () => {
      setUploaderState({loading: true, url: null})
      landingPageService.updateRecord(
        id,
        {image_or_video: null},
        () => {
          openNotificationWithIcon("success", "Actualización correcta", "");
          setUploaderState({loading: false, url: null })
        },
        () => {
          setUploaderState({loading: false, url: image_or_video.url })
          openNotificationWithIcon(
            "error",
            "Lo sentimos!",
            "Ocurrió un error al actualizar los datos."
          );
        },
      );
    },
    beforeUpload: (file) => {
      let validSizeInMb = file.size / 1024 / 1024 < 100;
      if (!validSizeInMb) {
        openNotificationWithIcon(
          "error",
          "Archivo inválido!",
          "El archivo debe ser menor a 100 mb."
        );
      }
      return validSizeInMb;
    },
    onChange: () => setUploaderState({loading: true, url: null}),
    onSuccess: (data) => {
      if(data.image_or_video.url) {
        openNotificationWithIcon("success", "Actualización correcta", "");
        setUploaderState({loading: false, url: data.image_or_video.url })
      }
    }
  };

  const bannerUploaderProps = {
    name: "banner",
    action: `/api/v1/landing_pages/${id}`,
    method: "put",
    maxCount: 1,
    fileList: bannerUploaderState.url ? [{
        uid: '-1',
        name: getFileNameFromUrl(bannerUploaderState.url || null),
        status: 'done',
        url: banner?.url,
      }] : [],
    onRemove: () => {
      setBannerUploaderState({loading: true, url: null})
      landingPageService.updateRecord(
        id,
        {banner: null},
        () => {
          openNotificationWithIcon("success", "Actualización correcta", "");
          setBannerUploaderState({loading: false, url: null })
        },
        () => {
          setBannerUploaderState({loading: false, url: banner?.url })
          openNotificationWithIcon(
            "error",
            "Lo sentimos!",
            "Ocurrió un error al actualizar los datos."
          );
        },
      );
    },
    beforeUpload: (file) => {
      let validSizeInMb = file.size / 1024 / 1024 < 100;
      if (!validSizeInMb) {
        openNotificationWithIcon(
          "error",
          "Archivo inválido!",
          "El archivo debe ser menor a 100 mb."
        );
      }
      return validSizeInMb;
    },
    onChange: () => setBannerUploaderState({loading: true, url: null}),
    onSuccess: (data) => {
      if(data.banner?.url) {
        openNotificationWithIcon("success", "Actualización correcta", "");
        setBannerUploaderState({loading: false, url: data.banner.url })
      }
    }
  };

  const processEditor = (newValue) => {
    setDescriptionValue(newValue)
  };


  return (
   <div data-testid={`organizationConfiguration--${landingPage.type_page === "internal" ? 'interno' : 'externo'}`}>
     <Collapse defaultActiveKey={["1"]} expandIconPosition={"right"} ghost >
      <Panel
        header={
          <Title level={5}>
            {landingPage.type_page === "internal"
              ? "Portal interno"
              : "Portal externo"}
          </Title>
        }
        key="1"
        className="page-config"
      >
        <Form
          layout="vertical"
          onSubmit={(e) => handleUpdatePage(e)}
        >
          <Row>
            <Col sm={{ span: 24 }} xs={{ span: 24 }}>
              <Form.Item label="Banner de Inicio (Imagen o video menor a 100mb)" name="banner">
                {getFieldDecorator('banner') (
                <Dragger {...bannerUploaderProps} disabled={bannerUploaderState.loading}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  {bannerUploaderState.loading 
                    ? <Spin /> 
                    :  <p className="ant-upload-text"> Haz clic acá o arrastra tu archivo para cargarlo </p>
                  }
                </Dragger>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col sm={{ span: 24 }} xs={{ span: 24 }}>
              <Form.Item label="Título" name="title">
                {getFieldDecorator('title', { initialValue: title }) (
                  <Input />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col sm={{ span: 24 }} xs={{ span: 24 }}>
              <Form.Item label="Imagen (480x320px) o video (máx 100mb)" name="file">
                {getFieldDecorator('file') (
                <Dragger {...uploaderProps} disabled={uploaderState.loading}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  {uploaderState.loading 
                    ? <Spin /> 
                    :  <p className="ant-upload-text"> Haz clic acá o arrastra tu archivo para cargarlo </p>
                  }
                </Dragger>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col sm={{ span: 24 }} xs={{ span: 24 }}>
              <Form.Item label="Descripción" name="description">
                <Editor
                  onInit={(evt, editor) => (editorRef.current = editor)}
                  apiKey="uyopvwfpyiul3yi3ew6kdhyj2j485rs6vcxbrtdxrq0j2h5d"
                  onEditorChange={(newValue, editor) => processEditor(newValue)}
                  initialValue={description}
                  init={{
                    height: 400,
                    menubar: false,
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor textcolor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount",
                    ],
                    toolbar:
                      "undo redo bold italic bullist numlist removeformat alignleft aligncenter alignright alignjustify",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px } p {margin: 0}",
                  }}
                />
                <button onClick={log} style={{ display: "none" }}>
                </button>
              </Form.Item>
              
            </Col>
          </Row>
          <Row>
            <Col sm={{ span: 21 }} xs={{ span: 15 }}>
              <Form.Item label="Link" name="link">
                {getFieldDecorator("link", { initialValue: link })( 
                  <Input onChangeCapture={(e) => setLinkValue(e.target.value)} disabled={true} />
                )}
              </Form.Item>
            </Col>
            <Col sm={{ span: 2, offset: 1 }} xs={{ span: 8, offset: 1 }}>
              <Button
                icon="copy"
                style={{
                  width: "100%",
                  marginTop: "28px",
                  backgroundColor: "rgba(220, 220, 220, 0.5)",
                }}
                onClick={copy}
              >
                Copiar
              </Button>
            </Col>
          </Row>
          <Row>
            <Col sm={{ span: 12 }} xs={{ span: 12 }}>
              {landingPage.type_page === "internal" &&
                <Form.Item label="Mostrar filtro de navegación por áreas" name="show_area_filter">
                  <Switch checked={showAreaFilter} onChange={(check)=> setShowAreaFilter(check)} checkedChildren="Si" unCheckedChildren="No" />
                </Form.Item>
              }
            </Col>
            <Col sm={{ span: 12 }} xs={{ span: 12 }}>
              <Button
                style={{ float: "right" }}
                htmlType="submit"
                type="primary"
                size="large"
              >
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>
      </Panel>
    </Collapse>
   </div>
  );
};

const createForm = typeof Form.create === "function" ? Form.create : createPlaywrightForm;
const PageConfig = createForm({ name: "page_config" })(PageConfigForm)

export default PageConfig;
